import { Injectable } from '@angular/core';
import { Point3D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { pointToVector } from '../../../utils/point-cloud-utils';
import { AbstractMeshService } from '../abstract-mesh.service';
import { MeasurementLineHelper } from '../free-point-measurement/measurement-line-helper';
import { MeasurementPlaneHelper } from './measurement-plane-helper';

enum HelperIndex {
  Plane,
  Line,
}

@Injectable()
export class SubpointMeasurementService extends AbstractMeshService<
  MeasurementPlaneHelper | MeasurementLineHelper
> {
  constructor() {
    super();
    this.setUpSubscriptions();
  }

  private setUpSubscriptions() {
    this.subscribeTo(
      this.store('render')('subpointHeightMeasurement').$,
      (subpointHeightMeasurement) => {
        if (!subpointHeightMeasurement) {
          this.removeHelpers();
          return;
        }

        if (
          !this.helpers.has(HelperIndex.Plane) &&
          !this.helpers.has(HelperIndex.Line)
        ) {
          this.createHelpers();
        }

        const plane = this.getHelper<MeasurementPlaneHelper>(HelperIndex.Plane);
        const line = this.getHelper<MeasurementLineHelper>(HelperIndex.Line);

        const { reference, target } = subpointHeightMeasurement;
        const targetPosition: Point3D = [reference[0], reference[1], target[2]];
        plane.setPosition(targetPosition);
        line.update(pointToVector(reference), pointToVector(targetPosition));
      },
    );
  }

  private createHelpers() {
    this.addHelper(HelperIndex.Plane, new MeasurementPlaneHelper());
    this.addHelper(HelperIndex.Line, new MeasurementLineHelper());
  }

  private removeHelpers() {
    this.removeHelper(HelperIndex.Plane);
    this.removeHelper(HelperIndex.Line);
  }
}
